import { memo, useMemo, CSSProperties } from 'react';
import { ProjectColumnRow } from './ProjectColumnRow';
import { ColumnRowProps } from '../../ColumnRowProps';
import { COLUMN_WIDTH, BORDER, ROW_HEIGHT } from '../../../../CONSTANTS';

export const ProjectColumnContainer = memo(function ProjectColumnContainer({
    columnIndex,
    columnRow,
    rowId,
    isAdminProject,
    start,
}: ColumnRowProps & { start: number;}) {
    const style = useMemo(() => {
        return {
            width: `${COLUMN_WIDTH}px`,
            position: 'absolute',
            transform: `translateX(${start}px)`,
            top: 0,
            left: 0,
            boxSizing: 'border-box',
            borderBottom: BORDER,
            borderRight: BORDER,
			backgroundColor: "inherit",
			height: `${ROW_HEIGHT}px`,
        } as CSSProperties;
    }, [start]);

    return (
        <div style={style}>
            <ProjectColumnRow columnRow={columnRow} columnIndex={columnIndex} rowId={rowId} isAdminProject={isAdminProject} />
        </div>
    );
});
